import request from '@/utils/request'

// 查询预加单需求结果列表
export function apiScpPreOrderDemandBillResultList (query) {
  return request({
    url: '/scp/scpPreOrderDemandBillResult/list',
    method: 'get',
    params: query
  })
}

// 预加单-合计
export function apiScpPreOrderDemandStaticsSum (query) {
  return request({
    url: '/scp/scpPreOrderDemandBillResult/staticsSum',
    method: 'get',
    params: query
  })
}

// 根据年份查询结果日期列名列表
export function scpPreOrderDemandBillDatesListByYear (data) {
  return request({
    url: '/scp/scpPreOrderDemandBillDates/list',
    method: 'post',
    data: data
  })
}

// 更新预加单需求结果数据
export function apiScpPreOrderDemandBillResultUpdateData (data) {
  return request({
    url: '/scp/scpPreOrderDemandBillResult/updateData',
    method: 'post',
    data: data
  })
}

// 修改预加单需求结果
export function apiScpPreOrderDemandBillResultEdit (data) {
  return request({
    url: '/scp/scpPreOrderDemandBillResult/edit',
    method: 'post',
    data: data
  })
}

// 导出预加单需求结果列表
export function apiScpPreOrderDemandBillResultExport (data) {
  return request({
    url: '/scp/scpPreOrderDemandBillResult/export',
    method: 'post',
    data: data
  })
}

// 批量修改预加单需求结果
export function apiPreBatchUpdate (data) {
  return request({
    url: `/scp/scpPreOrderDemandBillResult/batchUpdate`,
    method: 'post',
    data: data
  })
}

// 查询摆场需求结果列表
  export function apiScpDemandPlacementBillList (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/list',
    method: 'post',
    data: data
  })
}

// 修改摆场需求结果
export function apiScpDemandPlacementBillEdit (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/edit',
    method: 'post',
    data: data
  })
}

// 执行供需运算
export function apiScpDemandPlacementBillCalculate (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/calculate',
    method: 'post',
    data: data
  })
}

// 导出摆场需求结果列表
export function apiScpDemandPlacementBillExport (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/export',
    method: 'post',
    data: data
  })
}

// 导出摆场需求分析列表
export function apiAnalysisExport (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/export',
    method: 'post',
    data: data
  })
}

// 查询摆场需求分析列表
export function apiAnalysisList (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/list',
    method: 'post',
    data: data
  })
}

// 获取已有的版本号
export function apiVersionList (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/version/list',
    method: 'post',
    data: data
  })
}

// 查询摆场需求分析列表-获取汇总数据行
export function placementSum (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/placement/sum',
    method: 'post',
    data: data
  })
}

// 查询摆场需求分析列表-获取需求分析明细
export function apiAnalysisDetailList (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/detail/list',
    method: 'post',
    data: data
  })
}

// 需求来源表-下推转零星需求
export function apiAnalysisPushDemand (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/pushDemand',
    method: 'post',
    data: data
  })
}

// 摆场需求分析列表-导出需求分析明细
export function apiAnalysisDetailExport (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/detail/export',
    method: 'post',
    data: data
  })
}

// 查询摆场需求汇总页列表
export function analysisSumList (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/sum/list',
    method: 'post',
    data: data
  })
}

// 导出摆场需求汇总页列表
export function analysisSumExport (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/sum/export',
    method: 'post',
    data: data
  })
}

// 批量修改摆场需求结果
export function demandPlacementBillEditBatch (data) {
  return request({
    url: '/scp/scpDemandPlacementBill/editBatch',
    method: 'post',
    data: data
  })
}

// 获取已有的来源单号
export function apiSourceCodeList (query) {
  return request({
    url: '/scp/scpDemandPlacementBill/analysis/sourceCode/list',
    method: 'get',
    params: query
  })
}
